import CityPageTemplate from "../city-template/CityPageTemplate";
import { beckleyConfig } from "./data";

export default function BeckleyPage() {
  return <CityPageTemplate config={beckleyConfig} />;
}